import Header from '../../infrastructure/components/Header';
import CTA from '../../infrastructure/components/CTA';
import Footer from '../../infrastructure/components/Footer';
import { Container } from '@chakra-ui/layout';
import { Text, Badge, Box, VStack } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const SkillsPage = () =>
(
    <>
    <Header />
    <Container py="40px" maxW="4xl">
        <Text fontSize="2xl" mb="30px">
        Estos programas estan hechos para que los revises tantas veces sea necesario.
        Cuanta más continuidad le des al programa, mejores serán los resultados.
        Lo que más importa es el progreso; ten en cuenta que toda mejoría indicará que vas en la dirección correcta.
        </Text>
        <VStack spacing={4}>
            <Box w="100%" borderWidth="1px" borderRadius="lg" overflow="hidden" fontFamily="Museo Sans Bold">
                <Box h="5px" bg="teal" />
                <Box p="4">
                    <Box display="flex" alignItems="baseline">
                    <Box color="gray.500" fontWeight="semibold" letterSpacing="wide" fontSize="xs" textTransform="uppercase" ml="1">GIMNASTICOS</Box>
                    </Box>
                    <Link to="/strictpullup">
                    <Text fontSize="xl" mt="2">Strict Pull Up</Text>
                    <Text fontSize="lg" fontFamily="Museo Sans">Requisitos: 5 Ring Rows (con los pies debajo de las anillas) y colgar de la barra por 5 a 10 segundos.</Text>
                    </Link>
                </Box>
            </Box>
            <Box w="100%" borderWidth="1px" borderRadius="lg" overflow="hidden" fontFamily="Museo Sans Bold">
                <Box h="5px" bg="teal" />
                <Box p="4">
                    <Box display="flex" alignItems="baseline">
                    <Box color="gray.500" fontWeight="semibold" letterSpacing="wide" fontSize="xs" textTransform="uppercase" ml="1">GIMNASTICOS</Box>
                    </Box>
                    <Link to="/toestobar">
                    <Text fontSize="xl" mt="2">Toes to Bar</Text>
                    <Text fontSize="lg" fontFamily="Museo Sans">Requisitos: 30 Secs Colgado de la barra.</Text>
                    </Link>
                </Box>
            </Box>
            <Box w="100%" borderWidth="1px" borderRadius="lg" overflow="hidden" fontFamily="Museo Sans Bold">
                <Box h="5px" bg="teal" />
                <Box p="4">
                    <Box display="flex" alignItems="baseline">
                    <Box color="gray.500" fontWeight="semibold" letterSpacing="wide" fontSize="xs" textTransform="uppercase" ml="1">GIMNASTICOS</Box>
                    </Box>
                    <Link to="/barmuscleup">
                    <Text fontSize="xl" mt="2">Bar Muscle Up</Text>
                    <Text fontSize="lg" fontFamily="Museo Sans">Requisitos: 7-10 Pull Ups Strictos.</Text>
                    </Link>
                </Box>
            </Box>
            <Box w="100%" borderWidth="1px" borderRadius="lg" overflow="hidden" fontFamily="Museo Sans Bold">
                <Box h="5px" bg="teal" />
                <Box p="4">
                    <Box display="flex" alignItems="baseline">
                    <Box color="gray.500" fontWeight="semibold" letterSpacing="wide" fontSize="xs" textTransform="uppercase" ml="1">GIMNASTICOS</Box>
                    </Box>
                    <Link to="/pushup">
                    <Text fontSize="xl" mt="2">Push Up</Text>
                    <Text fontSize="lg" fontFamily="Museo Sans">Requisitos: 30 segundos sostenidos de plank.</Text>
                    </Link>
                </Box>
            </Box>
            <Box w="100%" borderWidth="1px" borderRadius="lg" overflow="hidden" fontFamily="Museo Sans Bold">
                <Box h="5px" bg="teal" />
                <Box p="4">
                    <Box display="flex" alignItems="baseline">
                    <Box color="gray.500" fontWeight="semibold" letterSpacing="wide" fontSize="xs" textTransform="uppercase" ml="1">GIMNASTICOS</Box>
                    </Box>
                    <Link to="/handstandpushup">
                    <Text fontSize="xl" mt="2">Strict Hand Stand Push Up</Text>
                    <Text fontSize="lg" fontFamily="Museo Sans">Requisitos:  10 push ups.</Text>
                    </Link>
                </Box>
            </Box>
            <Box w="100%" borderWidth="1px" borderRadius="lg" overflow="hidden" fontFamily="Museo Sans Bold">
                <Box h="5px" bg="teal" />
                <Box p="4">
                    <Box display="flex" alignItems="baseline">
                    <Box color="gray.500" fontWeight="semibold" letterSpacing="wide" fontSize="xs" textTransform="uppercase" ml="1">GIMNASTICOS</Box>
                    </Box>
                    <Link to="/kippingpullup">
                    <Text fontSize="xl" mt="2">Kipping Pull Up</Text>
                    <Text fontSize="lg" fontFamily="Museo Sans">Requisitos:  5 Strict Pull Ups.</Text>
                    </Link>
                </Box>
            </Box>
        </VStack>
    </Container>
    <CTA />
    <Footer />
    </>
);

export default SkillsPage;